import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { FirebaseService } from '../../services/firebase.service';

import { Observable } from 'rxjs/Observable';

import { SortOptions } from '../../dictionaries';

import * as _ from 'lodash';

@Component({
  selector    : 'list-recipe',
  templateUrl : 'list-recipe.html',
  styleUrls   : [ 'list-recipe.scss' ]
})

export class ListRecipeComponent implements OnInit {
  items        : Observable<any>;
  isList       : boolean  = true;
  shared       : boolean  = false;
  sortOptions  : object[] = SortOptions;
  title        : string;
  ownerName    : string;
  uid          : string;
  itemID       : string;
  selectedSort : string;
  hasRecipes   : boolean;

  constructor(
    private firebaseService : FirebaseService,
    private router          : Router,
    private route           : ActivatedRoute
  ) {}

  ngOnInit() : void {
    Observable
	  	.zip(
	  		this.firebaseService.uid,
		    this.route.params
	    )
      .take(1)
	    .switchMap(([uid, params]) => {
        this.uid = uid;
        this.itemID = params['key'] || params['shared-key'] || params['recipe-key'];

        if (params['shared-key']) {
          this.shared = true;

          return this.firebaseService.getSharedList(uid, this.itemID);
        } else {
          if (params['recipe-key'])
            this.isList = false;

          return this.firebaseService.getListRecipe(uid, this.itemID, this.isList);
        }
      })
      .take(1)
      .subscribe(unwrappedItem => {
        // if this list or recipe doesn't exist for whatever reason, escape!
        if (!unwrappedItem.$exists())
          this.router.navigate(['lists']);

        if (this.shared) {
          this.ownerName = unwrappedItem.ownerName;

          unwrappedItem.list
            .take(1)
            .subscribe(unwrappedItem => this.title = unwrappedItem.name);
        } else {
          this.title = unwrappedItem.name;
        }

        this.items = this.firebaseService.displayItems();

        this.checkRecipes();
      });

    // retrieve initial list sort
    this.firebaseService.itemsSortSubject
      .take(2)
      .subscribe(sort => this.selectedSort = sort);
	}

  checkRecipes() : void {
    this.items
      .subscribe(items => {
        this.hasRecipes = !!items.filter(item => !!item.recipe).length;
      });
  }

  hideRecipeSort() : boolean {
    return !this.isList || !this.hasRecipes;
  }

  // when a user selects a new sort
  sort(event) {
    // new sort subject
    const sort = event.target.value;

    // update sort subject
    this.firebaseService.sortItemsBy(sort)
      .then(() => {
        this.selectedSort = sort;

        // save list sort
        this.firebaseService.updateListSort(this.uid, this.itemID, sort);
      });
  }
}


// WEBPACK FOOTER //
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-beta/src/app/components/list-recipe/list-recipe.ts